export const defaultTemporaryNotificationDomainState = {
    notifications: []
};
